"use client";
import React from "react";
import styled from "styled-components";
import { Label, LabelH2, P, Title } from "@motorata/base-ui.components.atoms.typography";
import { blockPadding, blockStyles, Box } from "@motorata/base-ui.components.atoms._atoms";
import Link from "next/link";
import { NextImage } from "../common/Image";

const BusinessProfileSection = () => {
  return (
    <Wrapper>
      <Content>
        <Title label="Dołącz do nas" elementType="label" center marginBottom="S">
          Utwórz swój profil biznesowy i zwiększ zasięgi swoich ofert
        </Title>
        <P small marginLeft="auto" marginRight="auto" maxWidth="900px" textAlign="center">
          Skontaktuj się z nami, aby utworzyć swój profil biznesowy i aktywować dostępne integracje. Otrzymuj
          powiadomienia oraz raporty o zainteresowaniu Twoimi ogłoszeniami przez użytkowników.
        </P>
        <PersonWrapper marginTop="L">
          <PersonImageWrapper>
            <NextImage
              fill
              objectFit="contain"
              priority={true}
              src="https://pl-motorata-s3-public.s3.eu-central-1.amazonaws.com/email_signature/profiles/katarzyna.sliwa.png"
              alt="Zdjęcie profilowe Katarzyna Śliwa"
            />
          </PersonImageWrapper>
          <PersonTextWrapper>
            <Label type="secondary" color="primary">Account Manager</Label>
            <LabelH2 marginBottom="S">Katarzyna Śliwa</LabelH2>
            <Box marginBottom="XS">
              <Link href="tel:+48607743045">
                <Label icon="phone" type="secondary">+48 607 743 045</Label>
              </Link>
            </Box>
            <Box>
              <Link href="mailto:katarzyna.sliwa@motorata.pl">
                <Label icon="email" type="secondary">katarzyna.sliwa@motorata.pl</Label>
              </Link>
            </Box>
          </PersonTextWrapper>
        </PersonWrapper>
      </Content>
    </Wrapper>
  );
};

export default BusinessProfileSection;

const PersonTextWrapper = styled(Box)`

`;

const PersonImageWrapper = styled(Box)`
  width: 125px;
  height: 125px;
  border-radius: 50%;
  background: ${({ theme }) => theme.color.background};
`;

const PersonWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  grid-gap: ${({ theme }) => theme.space.M};
  
  @media (max-width: 800px){
    flex-direction: column;
    align-items: center;
  }
`;

const Content = styled.div`
  margin: 0 auto;

  > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 800px) {
    padding: ${({ theme }) => theme.space.L};
  }
`;

const Wrapper = styled.div`
  ${blockStyles};
  ${blockPadding};
  background: white;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: ${({ theme }) => theme.variable.boxShadow};

  &::before {
    display: block;
    position: absolute;
    width: 30vw;
    height: 30vw;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.02);
    content: "";
    left: 0;
    top: 0;
    z-index: 0;
  }

  &::after {
    display: block;
    position: absolute;
    width: 30vw;
    height: 30vw;
    border-radius: 50%;
    transform: translate(50%, 50%);
    background: rgba(0, 0, 0, 0.02);
    content: "";
    right: 0;
    bottom: 0;
    z-index: 0;
  }
`;
